import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';

import moment from 'moment';

import { Report } from '~/components';
import { DateTime, Autocomplete, Select, RadioGroup } from '~/components/Form';

import { GPP } from '~/constants/perfil';

import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import * as Yup from 'yup';
import { t, parseDateString } from '~/helpers';

function Relresumooperacao() {
  const [open, setOpen] = useState(true);

  //NOVOS CAMPOS
  const [valuePosto, setValuePosto] = React.useState('');
  const [inputValuePosto, setInputValuePosto] = React.useState('');

  const [valueProduto, setValueProduto] = React.useState('');
  const [inputValueProduto, setInputValueProduto] = React.useState('');

  const [resumoMensal, setResumoMensal] = React.useState(true);

  const meses = [
    { value: '0', label: 'Janeiro' },
    { value: '1', label: 'Fevereiro' },
    { value: '2', label: 'Março' },
    { value: '3', label: 'Abril' },
    { value: '4', label: 'Maio' },
    { value: '5', label: 'Junho' },
    { value: '6', label: 'Julho' },
    { value: '7', label: 'Agosto' },
    { value: '8', label: 'Setembro' },
    { value: '9', label: 'Outubro' },
    { value: '10', label: 'Novembro' },
    { value: '11', label: 'Dezembro' },
  ];

  const thisMonth = new Date().getMonth();

  const anos = [];

  const minOffset = 0;
  const maxOffset = 60;
  const thisYear = new Date().getFullYear();
  for (let i = minOffset; i <= maxOffset; i++) {
    const year = thisYear - i;
    anos.push({ value: year, label: year });
  }

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const { profile } = useSelector((state) => state.user);

  const [disablePosto, setDisablePosto] = useState(false);

  async function handleValidate(param) {
    let schema;

    try {
      if (resumoMensal) {
        schema = Yup.object().shape({
          poco_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable(),
          prod_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable(),
        });
      } else {
        schema = Yup.object().shape({
          poco_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable(),
          prod_codigo: Yup.string()
            .required(t('s.geral.validacao.campoobrigatorio'))
            .nullable(),
          datahorainicial: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))

            .min(
              moment("2013-01-01"),
              'A data deve ser maior que 01/01/2013'
            )

            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
            
          datahorafinal: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(
              datahorafinal,
              `A data não pode ser superior a ${datahorafinal}`
            )
            .min(
              Yup.ref('datahorainicial'),
              'A data não pode ser inferior a Data inicial'
            ),
        });
      }
      
      await schema.validate(param, {
        abortEarly: false,
      });
    } catch (err) {
      const form = {};

      if (err instanceof Yup.ValidationError) {
        err.inner.forEach((error) => {
          form[error.path] = error.message.replace(`${error.path} `, '');
        });

        throw { form };
      }
    }
  }

  useEffect(() => {
    let mounted = true;
    if (mounted) {
      if (profile.glousuariotipo === GPP) {
        setValuePosto(profile.glousuariopostocodigo);
        setDisablePosto(true);
      }
    }
    return function cleanup() {
      mounted = false;
    };
  }, [profile]);

  function handleSerializeForm(params) {
    let dataIni = params.datahorainicial;
    let dataFim = params.datahorafinal;

    let mes = 0;
    if (params.mes) {
      mes = params.mes;
    } else {
      mes = thisMonth;
    }

    let ano = 0;
    if (params.ano) {
      ano = params.ano;
    } else {
      ano = thisYear;
    }

    let resumo = '';
    if (params.resumo) {
      resumo = params.resumo === 'M' ? 'Mensal' : 'Período';
    } else {
      resumo = 'Mensal';
    }

    if (resumo === 'Mensal') {
      let mdi = moment().set({
        day: 1,
        month: mes,
        year: ano,
        hour: 0,
        minute: 0,
        second: 0,
      });
      let mdf = moment().set({
        day: 1,
        month: mes,
        year: ano,
        hour: 23,
        minute: 59,
        second: 59,
      });
      mdi = moment(mdi).startOf('month').format('DD/MM/YYYY HH:mm:ss');
      mdf = moment(mdf).endOf('month').format('DD/MM/YYYY HH:mm:ss');
      dataIni = mdi;
      dataFim = mdf;
    }

    let datahorainicial = dataIni;
    let datahorafinal = dataFim;

    let unidade = '';
    if (params.poco_codigo) {
      unidade = params.poco_codigo;
    } else {
      unidade = '';
    }

    let unidadestr = '';
    if (params.poco_desc_abrev) {
      unidadestr = params.poco_desc_abrev;
    } else {
      unidadestr = '';
    }

    let produto = '';
    if (params.prod_codigo) {
      produto = params.prod_codigo;
    } else {
      produto = '';
    }

    let produtostr = '';
    if (params.prod_descricao) {
      produtostr = params.prod_descricao;
    } else {
      produtostr = '';
    }

    let tipo = 'pdf';
    if (params.formato) {
      tipo = params.formato;
    } else {
      tipo = 'pdf';
    }

    return {
      ...params,
      datahorainicial,
      datahorafinal,
      unidade,
      unidadestr,
      produto,
      produtostr,
      resumo,
      tipo,
    };
  }

  return (
    <Report
      open={open}
      onClose={() => setOpen(false)}
      title="Resumo da Operação"
      relatorio="RESUMOOPERACAO"
      validate={(param) => handleValidate(param)}
      serialize={(param) => handleSerializeForm(param)}
      initials={{
        datahorainicial,
        datahorafinal,
        resumo: 'M',
        mes: thisMonth,
        ano: thisYear,
      }}
    >
      <Autocomplete
        name="poco_codigo"
        label="poco_desc_abrev"
        title="Posto"
        id="poco_codigo"
        url="postoscomboios"
        unique="poco_codigo"
        value={valuePosto}
        inputValue={inputValuePosto}
        onChange={(event, newValue) => {
          setValuePosto(newValue);
        }}
        onInputChange={(event, newInputValuePosto) => {
          setInputValuePosto(newInputValuePosto);
        }}
        defaultValue=""
        hiddens={[{ name: 'poco_desc_abrev' }]}
        getValue={(value) => {
          if (value.poco_codigo !== null) {
            setValuePosto(value.poco_codigo);
          } else {
            setValuePosto('');
          }
        }}
        disabled={disablePosto}
      />

      <Autocomplete
        name="prod_codigo"
        label="prod_descricao"
        title="Produto"
        id="prod_codigo"
        url="produtos"
        unique="prod_codigo"
        value={valueProduto}
        inputValue={inputValueProduto}
        onChange={(event, newValue) => {
          setValueProduto(newValue);
        }}
        onInputChange={(event, newInputValueProtudo) => {
          setInputValueProduto(newInputValueProtudo);
        }}
        defaultValue=""
        hiddens={[{ name: 'prod_descricao' }]}
        getValue={(value) => {
          if (value.prod_codigo !== null) {
            setValueProduto(value.prod_codigo);
          } else {
            setValueProduto('');
          }
        }}
      />

      <Select
        name="resumo"
        variant="outlined"
        size="small"
        label="Resumo"
        defaultValue="M"
        options={[
          { value: 'M', label: 'Mensal' },
          { value: 'P', label: 'Período' },
        ]}
        getValue={(value) => {
          setResumoMensal(value === 'M');
        }}
      />

      {resumoMensal && (
        <>
          <Select
            name="mes"
            variant="outlined"
            size="small"
            label="Mês"
            options={meses}
          />

          <Select
            name="ano"
            variant="outlined"
            size="small"
            label="Ano"
            options={anos}
          />
        </>
      )}

      {!resumoMensal && (
        <>
          <DateTime time label="Data Inicial" name="datahorainicial" disableFuture />

          <DateTime time label="Data Final" name="datahorafinal" disableFuture />
        </>
      )}

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        serialize={(value) => value}
        row
      />
    </Report>
  );
}

export default Relresumooperacao;
